import React from 'react';
import { CheckIcon } from 'lucide-react';
import { coverage, solutionMetrics } from '../data/salesCopy';
export function SolutionSection() {
  return <section className="w-full bg-night" data-id="element-223" data-mp="3ablyw2cpc0u3">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-5 sm:py-16 lg:py-20" data-id="element-224" data-mp="3o9trjy2pgfzg">
        <div className="text-center" data-id="element-225" data-mp="3ja7dxniysxq4">
          <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-226" data-mp="3j95yz7ytvr34">
            The most complete system for guitar teachers
          </p>
          <h2 className="mt-4 font-display text-[1.75rem] uppercase leading-[1] tracking-tight text-cream sm:text-5xl" data-id="element-227" data-mp="3t7c21swdf39k">
            TeachersKit™
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-serif text-base italic leading-snug text-cream-muted sm:text-xl" data-id="element-228" data-mp="5vb2ih2dawet">
            The 6-volume “Anti-Abandonment” system for guitar teachers.
          </p>
          <p className="mx-auto mt-5 max-w-3xl text-[15px] leading-relaxed text-cream-muted sm:text-base" data-id="element-229" data-mp="fth570w006kq">
            Over 300 pages of complete guitar lesson plans, chord and strumming drills, tabs,
            melodies, scales and CAGED material. It’s not a theory book — it’s the toolbox you teach
            from, already prepared for you.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] font-medium leading-relaxed text-cream" data-id="element-230" data-mp="3f9r0on8cqhdh">
            Everything is delivered as print-ready PDF files sent to your email. No videos, no
            audiobooks, no platform to log into.
          </p>
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-3 sm:mt-12 sm:gap-4 md:grid-cols-4" data-id="element-231" data-mp="3u7jbx36v8jlv">
          {solutionMetrics.map(metric => <div key={metric.label} className="rounded-2xl border border-line bg-panel p-5 text-center" data-id="element-232" data-mp="2uoy7pp82cbf">
              <dd className="font-display text-3xl leading-none text-gold sm:text-4xl" data-id="element-233" data-mp="bv3m8wtkm5im">
                {metric.value}
              </dd>
              <dt className="mt-2 text-[11px] font-medium uppercase tracking-[0.12em] text-cream-muted sm:text-xs" data-id="element-234" data-mp="gu6grnbxctcc">
                {metric.label}
              </dt>
            </div>)}
        </dl>

        <div className="mt-12 rounded-2xl border border-line bg-night-deep p-6 sm:mt-16 sm:p-10" data-id="element-235" data-mp="27zji8ehy9xkt">
          <p className="text-center text-[10px] font-semibold uppercase tracking-[0.28em] text-gold sm:text-xs" data-id="element-236" data-mp="2mnxgsd8c2zvk">
            Total coverage
          </p>
          <h3 className="mt-3 text-center font-display text-xl uppercase leading-tight tracking-tight text-cream sm:text-3xl" data-id="element-237" data-mp="2vmrjmlc9cmhk">
            First chord to CAGED · Acoustic &amp; electric · Kids, teens and adults
          </h3>
          <ul className="mt-7 grid grid-cols-1 gap-x-10 gap-y-0 sm:grid-cols-2" data-id="element-238" data-mp="35k5rvxo124ys">
            {coverage.map(item => <li key={item.number} className="flex items-center gap-3 border-b border-line py-3.5" data-id="element-239" data-mp="30n6v17czbjww">
                <CheckIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-240" data-mp="1b9jxlloiz8lv" />
                <span className="text-[15px] font-medium text-cream" data-id="element-241" data-mp="169xnhl3zu8ha">{item.label}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}